
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "language",
  "title": "Multi Language",
  "sidebar_label": "Languages"
};
const slug = 'language';
const tableOfContents = [{
  "title": "Multi languages",
  "slug": "multi-languages",
  "children": []
}, {
  "title": "User App",
  "slug": "user-app",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#6b166f1b-7ab8-4db8-be51-02296890a655"
      }}>{`API REFERENCE`}</a></p>
    <_Heading level={2} id={"multi-languages"} nextElement={{
      "type": "paragraph"
    }}>Multi languages</_Heading>
    <p>{`As a platform owner, you have the option to enable multiple languages for your app. You can manage translations directly through the SuperAdmin by going to `}<inlineCode parentName="p">{`Settings > Strings Translation`}</inlineCode>{`.`}</p>
    <p>{`If you activate the multi-language feature, it will be available in every app string, as well as other items you create, such as categories, attribute values, payment gateway names, shipping delivery names, etc. This allows users to view and interact with your app in their preferred language.`}</p>
    <_Heading level={2} id={"user-app"} nextElement={{
      "type": "paragraph"
    }}>User App</_Heading>
    <p>{`Users have the option to select their preferred language for the app. If the platform owner has enabled multiple language support, users can select their language preference under the settings of the app.`}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
